import request from "../utils/request";

export const getQualifications = '/qualification/page';

export function getQualificationsByProduct(productId: number) {
    return request.get('/qualification/product', {params: {productId}});
}

export function addQualifications(name: string, key: string) {
    return request.request({
        url: '/qualification/',
        method: 'post',
        data: {name, key}
    })
}
